// extracted by mini-css-extract-plugin
export default {"exercise":"exercise_exercise__vV9Hc","info":"exercise_info__ZYkr0","ipaReader":"exercise_ipaReader__vzPX8"};